import React, { useEffect, useState } from 'react'
import { NavLink, useLocation, useMatch, useNavigate } from 'react-router-dom'

import { SvgIcon, Typography } from '@mui/material'
import { Box } from '@mui/system'

import { ChevronDownIcon } from 'Sui_Icons'

export const MenuItem = ({ title, icon, route, innnerSection, my, onClickCallback }) => {

    const navigate = useNavigate()

    const [isItemOpen, setItemOpen] = useState(false)

    const location = useLocation(route)

    const openInnerSections = location.pathname?.includes(route) || isItemOpen

    useEffect(() => {
        if (!location.pathname?.includes(route))
            setItemOpen(false)
    }, [useLocation(route)])



    const Icon = icon

    return (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                m: 2.2,
                my: my || '',
                cursor: 'pointer',
                '&:hover': { color: 'primary.main', '& .material-icons ': { color: 'primary.main' } }
            }}
                onClick={() => {
                    setItemOpen(!isItemOpen)
                    if (!innnerSection)
                        navigate('/dashboard/'+route)
                    if (onClickCallback)
                        onClickCallback()
                }}
            >
                <Icon sx={{ color: openInnerSections || location.pathname.includes(route) ? '#05c6c5' : '#8EA7C6' }} />
                <Typography
                    color={location?.pathname.includes(route) ? 'CaptionText' : '#8EA7C6'}
                    fontWeight={location?.pathname.includes(route) ? 'medium' : 'normal'}
                    sx={{ ml: 2, mr: 0.5 }} fontSize={14}>{title}</Typography>

                {!!innnerSection && <ChevronDownIcon size={'18px'} sx={{
                    display: 'flex',
                    transform: !openInnerSections ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'all ease .4s',
                    color: '#8EA7C6'
                }}
                />}
            </Box>
            <Box
                sx={{
                    alignItems: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    maxHeight: !openInnerSections ? '0px' : '1000px',
                    my: -0.75,
                    p: 0.25,
                    pl: 3,
                    '& .active': { color: 'primary.main' },
                    '& a': { color: 'grey.600' },
                    transition: 'all ease .4s',
                }}
            >
                {innnerSection?.map(item => <NavLink to={'/dashboard/' + item.route} >
                    <Typography
                        fontWeight={'medium'}
                        fontSize={13}
                        color={'#8EA7C6'}
                        sx={{ my: 1 }}>{item.title}</Typography>
                </NavLink>)}
            </Box>
        </>

    )
}
